import { Injectable } from "@angular/core";
import { AlertController, isPlatform } from "@ionic/angular";
import { ApiRequestService, AppData } from "..";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { HttpResponse } from "@angular/common/http";
import { APPSTORE_URL, PLAYSTORE_URL } from "src/app/core/constants/app-constants";
import { WebIntentService } from "./web-intent.service";
import {
  InAppBrowser,
  InAppBrowserOptions, InAppBrowserEvent
} from "@ionic-native/in-app-browser/ngx";

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  currentVersion: string;
  versionModal = 1;
  loggedDay = 1;
  forceUpdate: boolean;

  constructor(private appVersion: AppVersion,
    private apiSerive: ApiRequestService,
    private webIntentService: WebIntentService,
    private alertController: AlertController,
    private iab: InAppBrowser,
  ) { }

  async versionAPI() {
    this.appVersion.getVersionNumber().then((res) => {
      console.log("version number", res);
      this.currentVersion = res;
      AppData.appVersion = res;
      AppData.appVersionSub$.next(res);
      this.apiSerive
        .get("updateApk", `?id=${this.currentVersion}`)
        .then((res: HttpResponse<any>) => {
          console.log("version API response ", JSON.stringify(res.body.data));
          AppData.newUpdateReleased = true;
          if (this.versionModal === 1) {
            this.forceUpdate = res.body.data.forceUpdate;
            this.versionAlert(res.body.data);
          }
          this.versionModal++;
        });
      AppData.appVersionSub$.next(res);
      AppData.appVersion = res
    });
  }
  async versionAlert(versionObj) {
    let self = this;
    if (AppData.userLoginDay === "" || this.forceUpdate === true) {
      AppData.userLoginDaySub$.next("currentTime");
      if (versionObj.showModal) {
        const buttonsAct = [];
        versionObj.buttons.forEach((button) => {
          if (button.action === "cancel") {
            buttonsAct.push({
              text: button.text,
              cssClass: button.color,
            });
          } else {
            buttonsAct.push({
              text: button.text,
              cssClass: button.color,
              handler: () => {
                this.versionModal = 1;
                if (button.action === "playstore") {
                  const playStoreUrl = isPlatform("ios")
                    ? APPSTORE_URL
                    : PLAYSTORE_URL;
                  //window.open(this.playStoreUrl, '_system');
                  // this.iab.create(playStoreUrl, "_system", { location: "yes" });
                  // this.webIntentService.openUrl(playStoreUrl);
                  console.log("Opening URL: ", playStoreUrl);
                  self.iab.create(playStoreUrl, "_system");
                } else {
                  // Itunes URL
                }
                return false;
              },
            });
          }
        });
        const alert = await this.alertController.create({
          backdropDismiss: false,
          header: versionObj.title,
          message: versionObj.description,
          buttons: buttonsAct,
        });
        await alert.present();
      }
    }
  }


  getDate(datetime) {
    datetime = new Date(datetime).getTime();
    const now = new Date().getTime();
    if (isNaN(datetime)) {
      return "";
    }
    if (datetime < now) {
      var milisec_diff = now - datetime;
    } else {
      var milisec_diff = datetime - now;
    }
    let days = Math.floor(milisec_diff / 1000 / 60 / (60 * 24));
    if (this.loggedDay <= days) {
      AppData.userLoginDaySub$.next("");
      this.versionAPI();
    }
  }
}